module.exports = __webpack_public_path__ + "static/media/Lake-Village-II-Parking-Policy.e13bc19d.pdf";